import styled from 'styled-components';

export const ModalText = styled.p`
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0em;
  text-align: center;
  color: ${({ theme }) => theme.colors.main};
  padding: 12px 24px 0;
  & span {
    font-weight: 700;
  }
`;

export const ButtonFooter = styled.div`
  width: fit-content;
  margin: 30px auto 0;
  display: flex;
  gap: 13px;
`;
